export enum PageEnum {
  Editando = 1,
  Visualizando = 2,
  Incluindo = 3
}
